import { render, staticRenderFns } from "./detailsStep.vue?vue&type=template&id=408ce6b0&scoped=true"
import script from "./detailsStep.vue?vue&type=script&lang=js"
export * from "./detailsStep.vue?vue&type=script&lang=js"
import style0 from "./entryScreen.css?vue&type=style&index=0&id=408ce6b0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408ce6b0",
  null
  
)

export default component.exports